import { AlertTriangle, Loader2, RefreshCw } from 'lucide-react'

export interface StaleAnalysisBannerProps {
  onRecompute: () => void
  computing?: boolean
  note?: string
}

export function StaleAnalysisBanner({
  onRecompute,
  computing = false,
  note,
}: StaleAnalysisBannerProps) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl border border-[var(--destructive)]/30 bg-[var(--destructive)]/5 px-4 py-2.5">
      <div className="flex items-center gap-x-2 gap-y-0.5 min-w-0 max-md:flex-wrap">
        <AlertTriangle className="size-4 text-[var(--destructive)] shrink-0" />
        <span className="text-xs font-medium text-[var(--foreground)]">Analysis is stale</span>
        {note && (
          <span className="text-xs text-[var(--muted-foreground)] truncate max-md:whitespace-normal">
            — {note}
          </span>
        )}
      </div>
      <button
        type="button"
        onClick={onRecompute}
        disabled={computing}
        className="h-7 px-2.5 rounded-lg border border-[var(--destructive)]/40 bg-[var(--destructive)]/10 text-xs font-medium text-[var(--destructive)] inline-flex items-center gap-1.5 hover:bg-[var(--destructive)]/15 disabled:opacity-60 disabled:cursor-not-allowed shrink-0 max-md:h-9 max-md:px-3"
      >
        {computing ? <Loader2 className="size-3 animate-spin" /> : <RefreshCw className="size-3" />}
        Recompute
      </button>
    </div>
  )
}
